<template>
  <v-container fill-height fluid full-width>
      <v-text-field color="red" :loading="isloading" 
      disabled :hidden="ishidden" :style="ishidden == false ? '' :'display:none'"
      ></v-text-field>
    <v-row>
        <v-col cols=12 md=12 lg=12 sm=12>
        <v-card color="transparent" outlined width="100%">
            <v-toolbar color="transparent" flat class="toobarDashboard" height="50px">
                <v-toolbar-items class="hidden-sm-and-down">
                    <a v-for="(menu, i) in menuProduct" :key="i" :href="`/customer/orders/${menu.id}`" class="ancSetting">
                    <v-btn color="blue-grey darken-2" dark :class="`text-uppercase orderButton mr-5 elevation-0`" small>
                         {{menu.name}} 
                    </v-btn></a>
                </v-toolbar-items>
            </v-toolbar>         
        </v-card>
      </v-col>
    </v-row>
    <!--<v-row>
        <v-col cols=12 md=3 sm=3>
            <v-card outlined style="border-color:#1E88E5;">
            <v-card-text class="pt-0 pb-0 pl-5 pr-5">
                <v-row>
                    <v-col cols=4 md=4 sm=4 lg=4>
                        <v-icon color="primary" class="pa-0" size="50"> mdi-send</v-icon>
                    </v-col>
                    <v-col cols=8 md=8 sm=8 lg=8 class="text-right">
                        <p class="mb-0 mt-1 font-weight-bold display-1 blue--text text--darken-2">{{submittedRecords}}<br> <v-chip label class="ml-3" color="primary">Total Submitted</v-chip></p>
                        
                    </v-col>
                </v-row>
            </v-card-text>
            </v-card>
        </v-col>
        <v-col cols=12 md=3 sm=3>
            <v-card outlined="" style="border-color:#FFCA28;">
            <v-card-text class="pt-0 pb-0 pl-5 pr-5">
                <v-row>
                    <v-col cols=4 md=4 sm=4 lg=4>
                        <v-icon color="amber lighten-1" class="pa-0" size="50"> mdi-alarm-multiple</v-icon>
                    </v-col>
                    <v-col cols=8 md=8 sm=8 lg=8 class="text-right">
                        <p class="mb-0 mt-1 font-weight-bold display-1 amber--text text--lighten-1">{{penddingRecords}}<br> <v-chip label class="ml-3" color="amber lighten-1" dark>Pending</v-chip></p>
                    </v-col>
                </v-row>
            </v-card-text>
            </v-card>
        </v-col>
        <v-col cols=12 md=3 sm=3>
            <v-card outlined="" style="border-color:#66BB6A;">
            <v-card-text class="pt-0 pb-0 pl-5 pr-5">
                <v-row>
                    <v-col cols=4 md=4 sm=4 lg=4>
                        <v-icon color="green lighten-1" class="pa-0" size="50"> mdi-check-all</v-icon>
                    </v-col>
                    <v-col cols=8 md=8 sm=8 lg=8 class="text-right">
                        <p class="mb-0 mt-1 font-weight-bold display-1 green--text text--lighten-1"> {{approvedRecord}}<br> <v-chip label class="ml-3" color="green lighten-1" dark>Approved</v-chip></p>
                    </v-col>
                </v-row> 
            </v-card-text>
            </v-card>
        </v-col>
        <v-col cols=12 md=3 sm=3>
            <v-card outlined style="border-color:#EF5350;">
            <v-card-text class="pt-0 pb-0 pl-5 pr-5">
                <v-row>
                    <v-col cols=4 md=4 sm=4 lg=4>
                        <v-icon color="red lighten-1" class="pa-0" size="50"> mdi-cancel</v-icon>
                    </v-col>
                    <v-col cols=8 md=8 sm=8 lg=8 class="text-right">
                        <p class="mb-0 mt-1 font-weight-bold display-1 red--text text--lighten-1"> {{notApprovedRecords}}<br> <v-chip label class="ml-3" color="red lighten-1" dark>Not Approved</v-chip></p>
                    </v-col>
                </v-row>
            </v-card-text>
            </v-card>
        </v-col>
    </v-row>-->
    <!-- Dashboard start Here -->
    <v-row justify='center'>
      <v-col v-for="(data ,i ) in dashboardUpdatesData" :key="i" cols=12 
      :md="data.productForm == 'SaleFormB' ? '4' : '4'" :lg="data.productForm == 'SaleFormB' ? '4' : '4'" sm=12>
        <v-card class="cardShadow postionRealtive">
          <v-card-text class="py-1">
            <v-toolbar flat class="customboxtoolbar" color="transparent">
                <v-spacer></v-spacer>
                <h2 class="title font-weight-ragular text-uppercase">{{data.productName}}</h2>
                <v-spacer></v-spacer>
                <v-chip label small class="text-uppercase" color="red lighten-4" text-color="red">{{data.productNature}}</v-chip>
            </v-toolbar>
          </v-card-text><v-divider></v-divider>
          <v-spacer></v-spacer>
          <v-row align="center" style='min-height: 265px !important'>
            <!-- Format Purchase Form A -->
            <v-col v-if="data.productForm =='PurchaseFormA'" md=12 sm=12 cols=12 lg=12 class="pt-5 text-center">
                <v-card-text class="pt-0 pb-0">
                    <v-toolbar flat class="customboxtoolbar" color="transparent" dense>
                        <div class="text-right">
                            <small class="smalltext">Condition</small>
                            <H1><span class="display-1 font-weight-regular" style="line-height:0px;">₹</span>{{data.conditionRate}}</H1>
                            <small class="smalltext">42% Oil Content</small>
                        </div>
                        <v-spacer></v-spacer>
                            <v-divider color="black" height="40" class="mt-0" vertical></v-divider>
                        <v-spacer></v-spacer>
                        <div class="text-right">
                            <small class="smalltext">Non Condition</small>
                            <H1><span class="display-1 font-weight-regular" style="line-height:0px;">₹</span>  {{data.nonConditionRate}}</H1>
                            <small class="smalltext white--text">.</small>
                        </div>
                    </v-toolbar>
                </v-card-text>
                <v-card-text class="py-0">
                    <v-toolbar flat class="customboxtoolbar" color="transparent" dense>
                        <span v-if="data.conditionRate == null || data.conditionRate == 0">
                            <v-chip label small color="red" dark class='mt-0'><v-icon class="mr-3" small>mdi-power-settings</v-icon>Purchase Closed</v-chip>
                        </span>
                        <span v-else>
                            <v-btn v-if="data.MSA == 'bidNow'" small color="blue-grey darken-2" dark @click="formType = data.productForm;updateId=data.id;cond='condition';orderBox=true; ">Bid Now</v-btn>
                            <v-btn v-if="data.MSA == 'update'" small color="blue-grey darken-2" dark @click="uFormType = data.productForm;orderId=data.MSAId;cond='condition';updateBox=true; ">Update</v-btn>
                            <v-btn v-if="data.MSA == 'approved'" small color="blue-grey darken-2" dark @click="uFormType = data.productForm;orderId=data.MSAId;cond='condition';updateBox=true; " class="buttonanimation">Approve</v-btn>
                        </span>
                        <v-spacer></v-spacer>
                        <span v-if="data.nonConditionRate == null || data.nonConditionRate == 0">
                            <v-chip label small color="red" dark class='mt-0'><v-icon class="mr-3" small>mdi-power-settings</v-icon>Purchase Closed</v-chip>
                        </span>
                        <span v-else>
                            <v-btn v-if="data.MSB == 'bidNow'" small color="blue-grey darken-2" dark @click="formType = data.productForm;updateId=data.id;cond='non-condition';orderBox=true; ">Bid Now</v-btn>
                            <v-btn v-if="data.MSB == 'update'" small color="blue-grey darken-2" dark @click="uFormType = data.productForm;orderId=data.MSBId;cond='non-condition';updateBox=true; ">Update</v-btn>
                            <v-btn v-if="data.MSB == 'approved'" small color="blue-grey darken-2" dark @click="uFormType = data.productForm;orderId=data.MSBId;cond='non-condition';updateBox=true; " class="buttonanimation">Approve</v-btn>
                        </span>
                        <!--<v-btn small color="blue-grey darken-2" dark @click="formType = data.productForm;updateId=data.id;cond='non-condition';orderBox=true;">Bid Now</v-btn>-->
                    </v-toolbar>
                </v-card-text>
            </v-col>
            <!-- End Format Purchase Form A -->

            <!-- Format Purchase Form B -->
            <v-col v-if="data.productForm =='PurchaseFormB'" md=12 sm=12 cols=12 lg=12 class="pt-5 text-center">
                <v-card-text class="pt-0 pb-0">
                    <v-toolbar flat class="customboxtoolbar" color="transparent">
                        <div class="text-right">
                            <small class="smalltext white--text">.</small>
                            <H1><span class="display-1 font-weight-regular" style="line-height:0px;">₹</span>{{data.conditionRate}}</H1>
                            <small class="smalltext">Solvent Condition</small>
                        </div>
                        <v-spacer></v-spacer>
                            <v-divider color="black" height="40" class="mt-0" vertical></v-divider>
                        <v-spacer></v-spacer>
                        <div class="text-right">
                            <small class="smalltext white--text">.</small>
                            <H1><span class="display-1 font-weight-regular" style="line-height:0px;">₹</span>{{data.nonConditionRate}}</H1>
                            <small class="smalltext">Non-Condition</small>
                        </div>
                    </v-toolbar>
                </v-card-text>
                <v-card-text class="py-0">
                    <v-toolbar flat class="customboxtoolbar" color="transparent" dense>
                        <span v-if="data.conditionRate == null || data.conditionRate == 0">
                            <v-chip label small color="red" dark class='mt-0'><v-icon class="mr-3" small>mdi-power-settings</v-icon>Purchase Closed</v-chip>
                        </span>
                        <span v-else>
                        <v-btn v-if="data.MCKA == 'bidNow'" small color="blue-grey darken-2" dark @click="formType = data.productForm;updateId=data.id;cond='solvent-condition';orderBox=true; ">Bid Now</v-btn>
                        <v-btn v-if="data.MCKA == 'update'" small color="blue-grey darken-2" dark @click="uFormType = data.productForm;orderId=data.MCKAId;updateBox=true; ">Update</v-btn>
                        <v-btn v-if="data.MCKA == 'approved'" small color="blue-grey darken-2" dark @click="uFormType = data.productForm;orderId=data.MCKAId;cond='solvent-condition';updateBox=true; " class="buttonanimation">Approve</v-btn>
                        </span>
                        <v-spacer><p class="mt-5 mr-5">JUTE BAG</p></v-spacer>
                        <span v-if="data.nonConditionRate == null || data.nonConditionRate == 0">
                            <v-chip label small color="red" dark class='mt-0'><v-icon class="mr-3" small>mdi-power-settings</v-icon>Purchase Closed</v-chip>
                        </span>
                        <span v-else>
                        <v-btn v-if="data.MCKB == 'bidNow'" small color="blue-grey darken-2" dark @click="formType = data.productForm;updateId=data.id;cond='solvent-non-condition';orderBox=true; ">Bid Now</v-btn>
                        <v-btn v-if="data.MCKB == 'update'" small color="blue-grey darken-2" dark @click="uFormType = data.productForm;orderId=data.MCKBId;updateBox=true; ">Update</v-btn>
                        <v-btn v-if="data.MCKB == 'approved'" small color="blue-grey darken-2" dark @click="uFormType = data.productForm;orderId=data.MCKBId;updateBox=true; " class="buttonanimation">Approve</v-btn>
                        </span>
                    </v-toolbar>
                </v-card-text>
            </v-col>
            <!-- End Format Purchase Form B -->

            <!-- Format Purchase Form C -->
            <v-col v-if="data.productForm =='PurchaseFormC'" md=12 sm=12 cols=12 lg=12 class="pt-5 text-center">
                <v-card-text class="pt-0 pb-0">
                    <v-toolbar flat class="customboxtoolbar" color="transparent">
                        <div class="text-right">
                            <small class="smalltext">EX-LOOSE RATE</small>
                            <H1><span class="display-1 font-weight-regular" style="line-height:0px;">₹</span>{{data.looseRatePbHr}}</H1>
                            <small class="smalltext">PB/HR</small>
                        </div>
                        <v-spacer></v-spacer>
                            <v-divider color="black" height="40" class="mt-0" vertical></v-divider>
                        <v-spacer></v-spacer>
                        <div class="text-right">
                            <small class="smalltext">EX-LOOSE RATE</small>
                            <H1><span class="display-1 font-weight-regular" style="line-height:0px;">₹</span>{{data.looseRateSumerpur}}</H1>
                            <small class="smalltext">Sumerpur</small>
                        </div>
                    </v-toolbar>
                </v-card-text>
                <v-card-text class="py-0">
                    <v-toolbar flat class="customboxtoolbar" color="transparent" dense>
                        <span v-if="data.looseRatePbHr == null || data.looseRatePbHr == 0">
                            <v-chip label small color="red" dark class='mt-0'><v-icon class="mr-3" small>mdi-power-settings</v-icon>Purchase Closed</v-chip>
                        </span>
                        <span v-else>
                        <v-btn v-if="data.MSOLA == 'bidNow'" small color="blue-grey darken-2" dark @click="formType = data.productForm;updateId=data.id;cond='pb/hr';orderBox=true; ">Bid Now</v-btn>
                        <v-btn v-if="data.MSOLA == 'update'" small color="blue-grey darken-2" dark @click="uFormType = data.productForm;orderId=data.MSOLAId;updateBox=true; ">Update</v-btn>
                        <v-btn v-if="data.MSOLA == 'approved'" small color="blue-grey darken-2" dark @click="uFormType = data.productForm;orderId=data.MSOLAId;updateBox=true; " class="buttonanimation">Approve</v-btn>
                        </span>
                        <v-spacer></v-spacer>
                        <span v-if="data.looseRateSumerpur == null || data.looseRateSumerpur == 0">
                            <v-chip label small color="red" dark class='mt-0'><v-icon class="mr-3" small>mdi-power-settings</v-icon>Purchase Closed</v-chip>
                        </span>
                        <span v-else>
                        <v-btn v-if="data.MSOLB == 'bidNow'" small color="blue-grey darken-2" dark @click="formType = data.productForm;updateId=data.id;cond='sumerpur';orderBox=true; ">Bid Now</v-btn>
                        <v-btn v-if="data.MSOLB == 'update'" small color="blue-grey darken-2" dark @click="uFormType = data.productForm;orderId=data.MSOLBId;updateBox=true; ">Update</v-btn>
                        <v-btn v-if="data.MSOLB == 'approved'" small color="blue-grey darken-2" dark @click="uFormType = data.productForm;orderId=data.MSOLBId;updateBox=true; " class="buttonanimation">Approve</v-btn>
                        </span>
                    </v-toolbar>
                </v-card-text>
                
            </v-col>
            <!-- End Format Purchase Form C -->

            <!-- Format Sale Form A -->
            <v-col v-if="data.productForm =='SaleFormA'" md=12 sm=12 cols=12 lg=12 class="pt-5 text-center">
                <v-card-text class="pt-0 pb-0">
                    <v-toolbar flat class="customboxtoolbar" color="transparent">
                        <div class="text-right">
                            <small class="smalltext">LOOSE READY</small>                    
                            <H1><span class="display-1 font-weight-regular" style="line-height:0px;">₹</span>{{data.readyRate}}</H1>
                            <small class="smalltext">Upto {{data.readyLiftingIn}}</small>
                        </div>
                        <v-spacer></v-spacer>
                            <v-divider color="black" height="40" class="mt-0" vertical></v-divider>
                        <v-spacer></v-spacer>
                        <div class="text-right">
                            <small class="smalltext">LOOSE FORWARD</small>
                            <H1><span class="display-1 font-weight-regular" style="line-height:0px;">₹</span>{{data.forwardRate}}</H1>
                            <small class="smalltext">Upto {{data.forwardLiftingIn}}</small>
                        </div>
                    </v-toolbar>
                </v-card-text>
                <v-card-text class="py-0">
                    <v-toolbar flat class="customboxtoolbar" color="transparent" dense>
                        <span v-if="data.readyRate == null || data.readyRate == 0">
                            <v-chip label small color="red" dark class='mt-0'><v-icon class="mr-3" small>mdi-power-settings</v-icon>Sale Closed</v-chip>
                        </span>
                        <span v-else>
                        <v-btn v-if="data.buttonA == 'bidNow'" small color="blue-grey darken-2" dark @click="formType = data.productForm;updateId=data.id;cond='ready';orderBox=true;">Bid Now</v-btn>
                        <v-btn v-if="data.buttonA == 'update'" small color="blue-grey darken-2" dark @click="uFormType = data.productForm;orderId=data.buttonAId;updateBox=true; ">Update</v-btn>
                        <v-btn v-if="data.buttonA == 'approved'" small color="blue-grey darken-2" dark @click="uFormType = data.productForm;orderId=data.buttonAId;updateBox=true; " class="buttonanimation">Approve</v-btn>
                        </span>
                        <v-spacer></v-spacer>
                        <span v-if="data.forwardRate == null || data.forwardRate == 0">
                            <v-chip label small color="red" dark class='mt-0'><v-icon class="mr-3" small>mdi-power-settings</v-icon>Sale Closed</v-chip>
                        </span>
                        <span v-else>
                        <v-btn v-if="data.buttonB == 'bidNow'" small color="blue-grey darken-2" dark @click="formType = data.productForm;updateId=data.id;cond='forward';orderBox=true;">Bid Now</v-btn>
                        <v-btn v-if="data.buttonB == 'update'" small color="blue-grey darken-2" dark @click="uFormType = data.productForm;orderId=data.buttonBId;updateBox=true; ">Update</v-btn>
                        <v-btn v-if="data.buttonB == 'approved'" small color="blue-grey darken-2" dark @click="uFormType = data.productForm;orderId=data.buttonBId;updateBox=true; " class="buttonanimation">Approve</v-btn>
                        </span>
                    </v-toolbar>
                </v-card-text>
            </v-col>
            <!-- End Format Sale Form A -->

            <!-- Format Sale Form B -->
            <v-col v-if="data.productForm =='SaleFormB'" md=12 sm=12 cols=12 lg=12 class="pt-1 text-center">
                <span style="display:none;">{{locationId = data.locationId}}</span>
                <v-card-text class="pt-0 pb-0">
                    <v-toolbar flat class="customboxtoolbar" color="transparent">
                    <div class="text-right">
                        <small class="smalltext">EX READY</small>
                        <H1><span class="display-1 font-weight-regular" style="line-height:0px;">₹</span>{{data.readyRate}}</H1>
                        <small class="smalltext">Lifting within {{data.readyLiftingIn}} Days</small>
                    </div>
                    <v-spacer></v-spacer>
                            <v-divider color="black" height="20" class="mt-4" vertical></v-divider>
                    <v-spacer></v-spacer>
                    <div class="text-right">
                        <small class="smalltext">EX FORWARD</small>
                        <H1><span class="display-1 font-weight-regular" style="line-height:0px;">₹</span>{{data.forwardRate}}</H1>
                        <small class="smalltext">Lifting within {{data.forwardLiftingIn}} Days</small>
                    </div>
                    </v-toolbar>
                    <v-toolbar flat class="customboxtoolbar mb-3" color="transparent" dense>
                        <span v-if="data.readyRate == null || data.readyRate == 0">
                            <v-chip label small color="red" dark class='mt-0'><v-icon class="mr-3" small>mdi-power-settings</v-icon>Sale Closed</v-chip>
                        </span>
                        <span v-else>
                        <v-btn v-if="data.MDA == 'bidNow'" small color="blue-grey darken-2" dark @click="formType = data.productForm;updateId=data.id;cond='ready';OrdType='EX';orderBox=true; ">Bid Now</v-btn>
                        <v-btn v-if="data.MDA == 'update'" small color="blue-grey darken-2" dark @click="uFormType = data.productForm;orderId=data.MDAId;updateBox=true; ">Update</v-btn>
                        <v-btn v-if="data.MDA == 'approved'" small color="blue-grey darken-2" dark @click="uFormType = data.productForm;orderId=data.MDAId;updateBox=true; " class="buttonanimation">Approve</v-btn>
                        </span>
                        <v-spacer></v-spacer>
                        <span v-if="data.forwardRate == null || data.forwardRate == 0">
                            <v-chip label small color="red" dark class='mt-0'><v-icon class="mr-3" small>mdi-power-settings</v-icon>Sale Closed</v-chip>
                        </span>
                        <span v-else>
                        <v-btn v-if="data.MDB == 'bidNow'" small color="blue-grey darken-2" dark @click="formType = data.productForm;updateId=data.id;cond='forward';OrdType='EX';orderBox=true; ">Bid Now</v-btn>
                        <v-btn v-if="data.MDB == 'update'" small color="blue-grey darken-2" dark @click="uFormType = data.productForm;orderId=data.MDBId;updateBox=true; ">Update</v-btn>
                        <v-btn v-if="data.MDB == 'approved'" small color="blue-grey darken-2" dark @click="uFormType = data.productForm;orderId=data.MDBId;updateBox=true; " class="buttonanimation">Approve</v-btn>
                        </span>
                    </v-toolbar>
                    <v-divider class="my-2"></v-divider>
                    <v-toolbar flat class="customboxtoolbar" color="transparent">
                        <div class="text-right">
                            <small class="smalltext">FOR READY</small>
                            <H1> <span class="display-1 font-weight-regular" style="line-height:0px;">₹</span>{{data.forReadyRate}}</H1>
                            <small class="smalltext">Lifting within {{data.readyLiftingIn}} Days</small>
                        </div>
                        <v-spacer> PP BAG </v-spacer> 
                        <div class="text-right">
                            <small class="smalltext">FOR FORWARD</small>
                            <H1> <span class="display-1 font-weight-regular" style="line-height:0px;">₹</span>{{data.forForwardRate}}</H1>
                            <small class="smalltext">Lifting within {{data.forwardLiftingIn}} Days</small>
                        </div>
                    </v-toolbar>
                </v-card-text>
                <v-card-text class="py-0">
                    <v-toolbar flat class="customboxtoolbar" color="transparent" dense>
                        <span v-if="data.forReadyRate == null || data.forReadyRate == 0">
                            <v-chip label small color="red" dark class='mt-0'><v-icon class="mr-3" small>mdi-power-settings</v-icon>Sale Closed</v-chip>
                        </span>
                        <span v-else>
                            <v-btn v-if="data.MDC == 'bidNow'" small color="blue-grey darken-2" dark @click="formType = data.productForm;updateId=data.id;cond='ready';OrdType='FOR';orderBox=true; ">Bid Now</v-btn>
                            <v-btn v-if="data.MDC == 'update'" small color="blue-grey darken-2" dark @click="uFormType = data.productForm;orderId=data.MDCId;updateBox=true; ">Update</v-btn>
                            <v-btn v-if="data.MDC == 'approved'" small color="blue-grey darken-2" dark @click="uFormType = data.productForm;orderId=data.MDCId;updateBox=true; " class="buttonanimation">Approve</v-btn>
                        </span>
                        <v-spacer></v-spacer> 
                        <p class="my-0">
                            <v-autocomplete :items="locationRecord" v-model="locationId" @change="fetchbyloaction()" color="amber" item-text="location" item-value="id" 
                            outlined label="Get Quotes" class="locationChanger" dense hide-details></v-autocomplete>
                        </p>
                         <v-spacer></v-spacer>
                         <span v-if="data.forForwardRate == null || data.forForwardRate == 0">
                            <v-chip label small color="red" dark class='mt-0'><v-icon class="mr-3" small>mdi-power-settings</v-icon>Sale Closed</v-chip>
                        </span>
                        <span v-else>
                        <v-btn v-if="data.MDD == 'bidNow'" small color="blue-grey darken-2" dark @click="formType = data.productForm;updateId=data.id;cond='forward';OrdType='FOR';orderBox=true; ">Bid Now</v-btn>
                        <v-btn v-if="data.MDD == 'update'" small color="blue-grey darken-2" dark @click="uFormType = data.productForm;orderId=data.MDDId;updateBox=true; ">Update</v-btn>
                        <v-btn v-if="data.MDD == 'approved'" small color="blue-grey darken-2" dark @click="uFormType = data.productForm;orderId=data.MDDId;updateBox=true; " class="buttonanimation">Approve</v-btn>
                        </span>
                    </v-toolbar>
                </v-card-text>
            </v-col>
            <!-- End Format Sale Form B -->
          </v-row>
          <v-divider></v-divider>
            <v-card-text class="pa-3">
            <v-toolbar flat class="customboxtoolbar" color="transparent">
              <label class="text-uppercase font-weight-bold caption grey--text text--darken-2">Last Update: {{data.CreatedAt}}</label>
                <v-spacer></v-spacer>
                <router-link :to="{name:'customerorder',params:{product:data.productId}}">
                    <v-btn color="amber" x-small class="elevation-0 mt-0 mb-0 mx-0">Check Orders</v-btn>
                </router-link>
            </v-toolbar>
          </v-card-text>
        </v-card>
      </v-col> 
          
    </v-row>
    <v-dialog v-model="orderBox" persistent transition="dialog-bottom-transition" max-width="800px">
        <!-- ============ PURCHASE FORM A ============== -->
        <purchaseFormA 
        v-if="formType == 'PurchaseFormA'" 
        :edit="false" 
        :updateid="updateId"
        :cond="cond"
        @Response="action($event)"
        @close="orderBox=false"/>
        <!-- =============== PURCHASE FORM B ============ -->
        <purchaseFormB 
        v-if="formType == 'PurchaseFormB'" 
        :edit="false" 
        :updateid="updateId"
        :cond="cond"
        @Response="action($event)"
        @close="orderBox=false"/>
        <!-- =========== PURCHASE FORM C ============== -->
        <purchaseFormC 
        v-if="formType == 'PurchaseFormC'" 
        :edit="false" 
        :updateid="updateId"
        :cond="cond"
        @Response="action($event)"
        @close="orderBox=false"/>
        <!-- ============ SALES FORM A ================= -->
        <saleFormA 
        v-if="formType == 'SaleFormA'" 
        :edit="false" 
        :updateid="updateId"
        :cond="cond"
        @Response="action($event)"
        @close="orderBox=false"/>
        <!-- ============ SALES FORM B ================= -->
        <saleFormB 
        v-if="formType == 'SaleFormB'" 
        :edit="false" 
        :updateid="updateId"
        :cond="cond"
        :LocationId='locationId'
        :OrdType="OrdType"
        @Response="action($event)"
        @close="orderBox=false"/>
    </v-dialog>


    <v-dialog v-model="updateBox" persistent transition="dialog-bottom-transition" max-width="800px">
        <!-- ============ PURCHASE FORM A ============== -->
        <cPurchaseFormA 
        v-if="uFormType == 'PurchaseFormA'"
        :orderId="orderId"
        @Response="action($event)"
        @Close="updateBox=false"
        ></cPurchaseFormA>
        <!-- =============== PURCHASE FORM B ============ -->
        <cPurchaseFormB 
        v-if="uFormType == 'PurchaseFormB'"
        :orderId="orderId"
        @Response="action($event)"
        @Close="updateBox=false"
        ></cPurchaseFormB>
        <!-- =========== PURCHASE FORM C ============== -->
        <cPurchaseFormC 
        v-if="uFormType == 'PurchaseFormC'"
        :orderId="orderId"
        @Response="action($event)"
        @Close="updateBox=false"
        ></cPurchaseFormC>
        <!-- ============ SALES FORM A ================= -->
        <cSaleFormA 
        v-if="uFormType == 'SaleFormA'"
        :orderId="orderId"
        @Response="action($event)"
        @Close="updateBox=false"
        >
        </cSaleFormA>
        <!-- ============ SALES FORM B ================= -->
        <cSaleFormB 
        v-if="uFormType == 'SaleFormB'"
        :orderId="orderId"  
        :LocationId='locationId'      
        @Response="action($event)"
        @Close="updateBox=false"
        >
        </cSaleFormB>
    </v-dialog>
    <v-snackbar v-model="notificationBar" top center :color="notificationColor" multi-line> {{ notificationText }}
        <v-btn color="amber" text @click="notificationBar = false"> Close </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { SERVER_API } from '../../API'
import {bus} from '../../main'
import purchaseFormA from '../../components/customerform/purchaseFormA'
import purchaseFormB from '../../components/customerform/purchaseformB'
import purchaseFormC from '../../components/customerform/purcaseFormC'
import saleFormA from '../../components/customerform/saleFormA'
import saleFormB from '../../components/customerform/saleFormB'

import cPurchaseFormA from '../../components/approvedata/purchaseFormA'
import cPurchaseFormB from '../../components/approvedata/purchaseFormB'
import cPurchaseFormC from '../../components/approvedata/purchaseFormC'
import cSaleFormA from '../../components/approvedata/saleFormA'
import cSaleFormB from '../../components/approvedata/saleFormB'
export default {
    components:{
        purchaseFormA,
        purchaseFormB,
        purchaseFormC,
        saleFormA,
        saleFormB,
        // Customer
        cPurchaseFormA,
        cPurchaseFormB,
        cPurchaseFormC,
        cSaleFormA,
        cSaleFormB
    },
    created(){
        bus.$on('notify',() =>{
            this.fetchDataForDashboard();
            this.fetchApproved();
            this.fetchPending();
            this.fetchSubmitted();
            this.fetchNotApproved();
            this.fetchLocation();
        })
    },
    mounted(){
        this.fetchDataForDashboard();
        this.fetchApproved();
        this.fetchPending();
        this.fetchSubmitted();
        this.fetchNotApproved();
        this.fetchLocation();
        this.fetchProduct();
    },
    data(){
        return{
            //For Update And Approve Order
            isloading:true,
            ishidden:false,
            orderId:'',
            updateBox:false,
            OrdType:'',
            uFormType:'',
            locationId:'',
            locationRecord:[],
            //For Create New Order
            orderBox:false,
            updateId:'',
            cond:'',
            dashboardUpdatesData:[],
            formType:'',
        // Notification Setting
            notificationColor: 'black',
            notificationBar: false,
            notificationText:'',

        // Counter Var
            approvedRecord:'',
            notApprovedRecords:'',
            submittedRecords:'',
            penddingRecords:'',

            menuProduct:[]
        }
    },
    methods:{
        async fetchProduct(){
            try{
                const response = await this.$http.get(SERVER_API+'/product/byuser');
                this.menuProduct = response.data.data;
            }catch(error){
                /*if(error.code == 401){
                    this.notificationColor = 'red';
                    this.notificationBar = true;
                    this.notificationText = error;
                    this.$store.dispatch('destroyToken')
                    .then(() => {
                        location.reload();
                    }).catch(() => {
                        //
                    })
                }*/
            }
        },
        async fetchbyloaction(){
            const response = await this.$http.get(SERVER_API+'/custmor/dashboard/'+this.locationId);
            this.dashboardUpdatesData = response.data;
        },
        async fetchLocation(){
            const response = await this.$http.get(SERVER_API+'/location/records/active');
            this.locationRecord = response.data.data;
        },
        async fetchDataForDashboard(){
            const response = await this.$http.get(SERVER_API+'/custmor/dashboard');
            this.dashboardUpdatesData = response.data;
            if(this.dashboardUpdatesData){
                this.ishidden = true;
                this.isloading = false;
            }
        },
        show(id){
            alert(id);
        },
        makeMessage(error){
            if(error.response){
                //return error.response.data.errors;
                if(error.response.data.errors){
                    return ' '+error.response.data.errors.oQty.toString()+' ' + error.response.data.errors.oRate.toString();                    
                }else{
                    return error.response.data.message;
                }
            }else{
                return error;
            }
        },
        action(e){
            if(e.action == true){
                this.notificationColor = 'black';
                this.notificationBar = true;
                this.notificationText = e.message;
                //this.fetchall();
                this.orderBox = false;
                this.updateBox = false;
                this.fetchDataForDashboard();
                this.fetchApproved();
                this.fetchPending();
                this.fetchSubmitted();
                this.fetchNotApproved();
            }else{
                this.notificationColor = 'red';
                this.notificationBar = true;
                this.notificationText = this.makeMessage(e);
                //console.log(e);
            }
        },
        /*test(){
            bus.$emit('TESTBRO', 'The video is added.');
            //console.log('clear');
        },*/
        async fetchApproved(){
            const response = await this.$http.get(SERVER_API+'/customer/dashboard/counter/approved');
            this.approvedRecord = response.data
        },
        async fetchPending(){
            const response = await this.$http.get(SERVER_API+'/customer/dashboard/counter/pending');
            this.penddingRecords = response.data
        },
        async fetchSubmitted(){
            const  response = await this.$http.get(SERVER_API+'/customer/dashboard/counter/submitted');
            this.submittedRecords = response.data
        },
        async fetchNotApproved(){
            const response = await this.$http.get(SERVER_API+'/customer/dashboard/counter/notapproved');
            this.notApprovedRecords = response.data
        }
    }
}
</script>

<style>
.DashboardBoxSetting{
    min-height: 100px !important;
}
.customboxtoolbar .v-toolbar__content{
    height: auto !important;
    padding:0px !important;
}
.customboxtoolbar{
    height: auto !important;
}
.smalltext{
  font-size: 13.5px !important;
  line-height: 30px;  
  font-weight: 500 !important;
}
.ButtonSetting{
    position: absolute;
    bottom: -31px;
}
.locationChanger{
    max-width: 160px !important;
}
</style>